import { useEffect, useState } from "react";
import MemberLayout from "../components/MemberLayout";
import StatCard from "../components/StatCard";
import { api, formatRupiah, formatDate } from "../lib/api";
import { PiggyBank, HandCoins, Calendar, BadgeCheck } from "lucide-react";
import { Link } from "react-router-dom";

export default function MemberDashboard() {
  const [data, setData] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/member/dashboard").then((r) => setData(r.data));
    api.get("/member/simpanan").then((r) => setRecent(r.data.slice(0, 5)));
  }, []);

  return (
    <MemberLayout>
      <div className="space-y-6">
        {/* Welcome card */}
        <div className="relative overflow-hidden rounded-3xl bg-brand text-white p-6 shadow-sm">
          <div className="absolute -right-12 -top-12 w-40 h-40 rounded-full bg-white/10" />
          <div className="absolute -right-2 -bottom-10 w-28 h-28 rounded-full bg-gold/30" />
          <div className="relative">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/65">Selamat datang</div>
            <h1 className="font-heading font-extrabold text-2xl sm:text-3xl mt-1">{data?.member?.full_name || "—"}</h1>
            <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
              <span className="inline-flex items-center gap-1 rounded-full bg-white/15 px-3 py-1.5"><BadgeCheck size={12} /> {data?.member?.member_number || "Belum bernomor"}</span>
              <span className={"inline-flex items-center gap-1 rounded-full px-3 py-1.5 " + (data?.member?.status === "active" ? "bg-emerald-400/30" : "bg-amber-300/30")}>
                ● {data?.member?.status || "—"}
              </span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <StatCard testid="member-total-simpanan" label="Total Simpanan" value={formatRupiah(data?.total_simpanan)} icon={PiggyBank} accent="brand" />
          <StatCard testid="member-pinjaman-aktif" label="Pinjaman Aktif" value={formatRupiah(data?.active_pinjaman)} icon={HandCoins} accent="gold" />
          <StatCard testid="member-pokok" label="Simpanan Pokok" value={formatRupiah(data?.total_simpanan_pokok)} icon={PiggyBank} accent="info" />
          <StatCard testid="member-wajib" label="Simpanan Wajib" value={formatRupiah(data?.total_simpanan_wajib)} icon={PiggyBank} accent="success" />
        </div>

        <div className="bg-white rounded-3xl border border-brand/10 shadow-sm p-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gold-soft text-amber-600 flex items-center justify-center"><Calendar size={18} /></div>
            <div>
              <div className="font-heading font-bold text-brand-ink">{data?.member?.approved_at ? formatDate(data.member.approved_at) : formatDate(data?.member?.registered_at)}</div>
              <div className="text-xs text-brand-muted">Tanggal masuk anggota · {data?.membership_duration_days ?? 0} hari sebagai anggota</div>
            </div>
          </div>
        </div>

        <section className="bg-white rounded-3xl border border-brand/10 shadow-sm p-5">
          <div className="flex items-center justify-between mb-3">
            <h2 className="font-heading font-bold text-brand-ink">Transaksi Simpanan Terbaru</h2>
            <Link to="/simpanan" className="text-xs rounded-full bg-brand-soft text-brand px-3 py-1.5" data-testid="member-view-all-simpanan">Lihat Semua</Link>
          </div>
          {recent.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-brand/15 p-6 text-center text-brand-muted text-sm">Belum ada transaksi simpanan.</div>
          ) : (
            <ul className="divide-y divide-brand/10">
              {recent.map((r) => (
                <li key={r.id} className="py-3 flex items-center justify-between">
                  <div>
                    <div className="font-medium text-brand-ink capitalize">Simpanan {r.type}</div>
                    <div className="text-xs text-brand-muted">{formatDate(r.transaction_date)}</div>
                  </div>
                  <div className="font-semibold text-brand-ink">{formatRupiah(r.amount)}</div>
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </MemberLayout>
  );
}
